module.exports = __webpack_public_path__ + "static/img/system-4.805eb7d1.png";